export const changeTextIndent = (parsedDoc: Document) => {
  const paragraphs = parsedDoc.querySelectorAll('p')
  paragraphs.forEach((paragraph) => {
    const style = paragraph.getAttribute('style')
    if (style) {
      const styles = style.split(';')

      const newStyles: string[] = []
      let isMarginLeftExist = false

      styles.forEach((s) => {
        const [property, value] = s.split(':')
        if (property === 'text-indent' && parseFloat(value) > 0) {
          newStyles.push(`margin-left: ${value}`)
          isMarginLeftExist = true
        } else if (
          !property.includes('margin-left') ||
          (property.includes('margin-left') && !isMarginLeftExist)
        ) {
          newStyles.push(`${property}: ${value}`)
        }
      })

      const newStylesString = newStyles.join('; ')
      paragraph.setAttribute('style', newStylesString)
    }
  })
}
